import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiBaseUrl, prepareAuthHeaders } from "./apiBase";
import { salesApi } from "./salesApi";

export const exchangesApi = createApi({
  reducerPath: "exchangesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: apiBaseUrl,
    prepareHeaders: (headers) =>
      prepareAuthHeaders(headers, {
        acceptJson: true,
        contentTypeJson: true,
      }),
  }),
  tagTypes: ["Exchange"],
  endpoints: (builder) => ({
    fetchExchangesList: builder.query({
      query: (params = {}) => {
        const searchParams = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
          if (value === undefined || value === null || value === "") {
            return;
          }

          searchParams.set(key, String(value));
        });

        const queryString = searchParams.toString();
        return queryString ? `exchanges?${queryString}` : "exchanges";
      },
      transformResponse: (res) => (res?.success ? res.data : res ?? null),
      providesTags: (result) =>
        (result?.items || []).map((item) => ({ type: "Exchange", id: item.id })),
    }),

    createExchange: builder.mutation({
      query: (body) => ({
        url: "exchanges",
        method: "POST",
        body,
      }),
      transformResponse: (res) => (res?.success ? res.data : res ?? null),
      invalidatesTags: (result) =>
        result?.id ? [{ type: "Exchange", id: result.id }] : [],
      // Sales live in their own API slice; refresh the original sale so its
      // returned items and net value show up without a manual reload.
      async onQueryStarted(body, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch {
          return;
        }
        if (body?.originalSaleId) {
          dispatch(
            salesApi.util.invalidateTags([{ type: "Sale", id: body.originalSaleId }])
          );
        }
      },
    }),

    fetchExchangeById: builder.query({
      query: (exchangeId) => `exchanges/${exchangeId}`,
      transformResponse: (res) => (res?.success ? res.data : res ?? null),
      providesTags: (_result, _error, exchangeId) => [{ type: "Exchange", id: exchangeId }],
    }),
  }),
});

export const {
  useFetchExchangesListQuery,
  useCreateExchangeMutation,
  useFetchExchangeByIdQuery,
} = exchangesApi;
